import React from "react";
import ProfileImage from '../../../Common/ProfileImage';
import { ArrowBackHoc, 
  AudioCallHoc,
  sampleChatProfile, SampleGroupProfile,
  VideoCallHoc
  } from "../../../../assets/images";
import { useSelector } from "react-redux";
import TypingStatus from "../../Common/TypingStatus";
import { encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from "../../../../Helpers/Chat/webChatEncryptDecrypt";
import { CONNECTED, NO_INTERNET } from "../../../../Helpers/Constants";
import { formatUserIdToJid, isSingleChat, isGroupChat } from "../../../../Helpers/Chat/ChatHelper";
import { store } from "../../../../Redux/store";
import { addCallConnectionDate } from "../../../../Redux/feature/callConnectionDateSlice";
import { addShowConfrenceData } from "../../../../Redux/feature/showConfrenceDataSlice";
import { deleteAndDispatchAction, startCallingTimer } from "../../../../Helpers/Call/Call";
import SDK from "../../../../SDK";
import WebChatContactInfo from "../../ContactInfo/WebChatContactInfo";
import { getContactNameFromRoster, getDataFromRoster } from "../../../../Helpers/Chat/User";
import { hideModal, showModal } from "../../../../Redux/feature/popUpDataSlice";
import { muteLocalVideo } from "../../../../callback";
import callLogs from "../../../WebCall/CallLogs/callLog";
import { CHAT_TYPE_GROUP } from "../../../../Helpers/Chat/Constant";
import { blockOfflineMsgAction } from "../../../../Helpers/Utility";
import { toast } from "react-toastify";

let groupId = "";
const ConversationHeader = (props = {}) => {
  const {
    userData = [],
    displayNames,
    showonGoingcallDuration,
    groupMemberDetails = [],
    activeChatId,
    handlePopUpClassActive,
    conversationValue,
    isCallEnabled
  } = props;
  // const callActivate = false
  const storeData = useSelector((state) => state);
  /**
  // const { dynamicIcon = {} } = storeData;
  // const { mf_ArrowBack } = dynamicIcon?.data;
  */
  const { 
    vCardData,
    groupsData,
    rosterData,
    groupMembersData: { data: { participants } = {} } = {} , 
    featureFlagList:{data:featureFlagList={}},
    blockedContact,
    recentChatItems
  } = storeData
  const { popUpData:{ modalProps: { open } } } = storeData
  const [{ chatId, chatJid, chatType, roster={} ,recent ={} }]  = userData
  const [ displayName, setDisplayName] = React.useState('')
  const [ getImage, setImage ] = React.useState('')
  const [ getGroupImage, setGroupImage ] = React.useState('')
  const [ getName, setName ] = React.useState('')
  // // const [ getGroupName, setGroupName ] = React.useState('')
  const [ localRoster, setLocalRoaster ] = React.useState({})
  const [ userstatus, setUserStatus ] = React.useState(null)
  const { isOneToOneCallEnabled,
          isGroupCallEnabled 
        } = featureFlagList
  // const [ mobileNumber , setUserStatus ] = React.useState(null)
  const mobileNumber = roster.mobileNumber
  let preventMultipleClick = false;
  let premissionConst = "Permission denied";
  const [ conversationInfo , setconversationInfo] = React.useState({
    viewContactStatus: false,
    blocked: false,
    emailId: null,
    isAdminBlocked: false,
    isDeletedUser: false
  }) 

  const {
    isAdminBlocked,
    isDeletedUser
    } = conversationInfo

  React.useEffect(()=>{
    setUserDetails() 
  },[])

  React.useEffect(()=>{
    if (isGroupChat(chatType)) {
      const updateGroupInfo = filterProfileFromGroup(chatId)
      setName(updateGroupInfo?.groupName)
      if (updateGroupInfo) {
        // const { groupImage,thumbImage } = updateGroupInfo
        setDisplayName(getContactNameFromRoster(updateGroupInfo))
        setImage(updateGroupInfo.groupImage)
        setGroupImage(updateGroupInfo.thumbImage !== "" ? updateGroupInfo.thumbImage : updateGroupInfo.groupImage)
        setUserStatus(null)
      }
    }
  },[groupsData.id])

  React.useEffect(()=>{
    setUserDetails() 
  },[activeChatId])

  React.useEffect(()=>{
    if(isSingleChat(chatType)){
      const rosterInfo = filterProfileFromRoster(activeChatId)
      let adminStatus = rosterData?.data.find(element => element?.userId === activeChatId)?.isAdminBlocked
      if (rosterInfo) {
        const { image, isDeletedUser:deletedUser } = rosterInfo      
        setImage(image)
        setName(rosterInfo.displayName)
        setUserStatus(rosterInfo.status)
        setLocalRoaster(rosterInfo)
        setconversationInfo({
          ...conversationInfo,
          emailId: rosterInfo.emailId,
          isAdminBlocked:adminStatus,
          isDeletedUser: deletedUser
        })
      }
    }
  },[rosterData?.data, recentChatItems])

  const setUserDetails = () => {
    const { image, groupImage} = roster
    const displayRosterName = getContactNameFromRoster(roster)
    const isAdminBlockedDetail = roster.isAdminBlocked
    setDisplayName(displayRosterName)
    setImage(image || groupImage)
    setName(roster.displayName)
    setLocalRoaster(roster)
    setUserStatus(roster.status)
    setconversationInfo({
      ...conversationInfo,
      emailId: roster.emailId,
      isAdminBlocked:isAdminBlockedDetail,
      isDeletedUser: roster.isDeletedUser
    })
  }

  const filterProfileFromRoster = (messageFrom) => {
    const { rosterNames } = rosterData
    if (!rosterNames) return {};
    if (rosterNames.has(messageFrom)) {
        return rosterNames.get(messageFrom)
    }
    return {};
  }

  const filterProfileFromGroup = (messageFrom) => {
    const  { data: groupsDataArray = [] } = groupsData;
    return groupsDataArray.find((group) => messageFrom.indexOf(group.groupId) > -1);
  }

  const handlePopUp = (forceClose = false) => {
    if (open && !forceClose) {
      return;
  }
  setconversationInfo({
      ...conversationInfo,
      viewContactStatus: !conversationInfo.viewContactStatus
  })
  };

  const canSendMessage = () => {
    const chatMessageType = recent?.chatType;
    const fromUser = vCardData?.data?.fromUser
    if (chatMessageType === 'chat' || !participants) return true;
    return participants.find((profile) =>
        fromUser === profile.userId
    );
  }
  
  const closePopup = () => {
    store.dispatch(hideModal());
  }

  const backToRecentChat = () => {
    handlePopUpClassActive(false)
  };

  const nickName = chatType !== "groupchat" ? roster?.nickName : roster?.groupName

  const isRoomExist=()=> {
    let room = getFromLocalStorageAndDecrypt('roomName');
    return room !== null;
  }

  const showCallParticipants = (callType) => {
    if (isRoomExist()) {
      return;
    }
    if(blockOfflineMsgAction()) return
    if (isAdminBlocked || isDeletedUser || isBlocked) return;
    let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
    if (connectionStatus === CONNECTED) {
      let groupMembers = [];
      groupMemberDetails.map(participant => {
        const { userJid, username, GroupUser } = participant
        let user = userJid || username || GroupUser
        let currentUser = vCardData?.data?.fromUser;
        if (user !== currentUser) {
          groupMembers.push(user)
        }
      })

      if (groupMembers.length === 0) {
        toast.error("You are only one member in the group")
        return false
      } else if (groupMembers.length === 1) {
        makeGroupCall(callType, groupMembers);
      } else {
        groupId = formatUserIdToJid(activeChatId,CHAT_TYPE_GROUP);
        store.dispatch(showModal({
          open: true,
          modelType: 'callparticipants',
          groupName: displayName,
          groupMembers: groupMembers,
          groupuniqueId: groupId,
          groupMemberDetails: groupMemberDetails,
          makeGroupCall: makeGroupCall,
          callType: callType,
          currentCallUsersLength: 0,
          selectDefault: true,
          closePopup: closePopup
        }));
      }
    } else {
      toast.error(NO_INTERNET)
    }
  }

  const makeGroupCall = async (callType, groupCallMemberDetails) => {
    let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
    if (connectionStatus === "CONNECTED") {
        let fromuser = vCardData?.data?.fromUser;
        let users = [];
        let callMode = "onetomany";
        fromuser = formatUserIdToJid(fromuser);
        if (groupCallMemberDetails.length > 0) {
          groupCallMemberDetails.forEach(function (member) {
            if (member !== fromuser) {
              if (!member.includes("@")) {
                users.push(formatUserIdToJid(member));
              } else {
                users.push(member);
              }
            }
          });
        } else {
          users = [activeChatId];
        }
        let roomId = "";
        let call = null;
        /**
        // resetPinAndLargeVideoUser();
        */
        let callConnectionStatus = {
          callMode: callMode,
          callStatus: "CALLING",
          to: groupId,
          callType: callType,
          from: fromuser,
          userList: users.join(','),
          groupId
        }
        encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatus))
        encryptAndStoreInLocalStorage('callType', callType)
        encryptAndStoreInLocalStorage('callingComponent', true)
        encryptAndStoreInLocalStorage('callFrom', getFromLocalStorageAndDecrypt('loggedInUserJidWithResource'));
        const showConfrenceData = store.getState().showConfrenceData;
        const {
          data
        } = showConfrenceData;
        store.dispatch(addShowConfrenceData({
          localStream: data?.localStream,
          localVideoMuted: data?.localVideoMuted,
          localAudioMuted: data?.localAudioMuted,
          showComponent: true,
          callStatusText: 'Calling'
        }))
        store.dispatch(addCallConnectionDate(callConnectionStatus));
        try {
          if (callType === "audio") {
            muteLocalVideo(true);
            call = await SDK.makeVoiceCall(users, groupId);
          } else if (callType === "video") {
            muteLocalVideo(false);
            call = await SDK.makeVideoCall(users, groupId);
          }
          if (call.statusCode !== 200 && call.message !== premissionConst) {
            deleteAndDispatchAction();
          } else {
            roomId = call.roomId;
            encryptAndStoreInLocalStorage('roomName', roomId)
            callLogs.insert({
              "callMode": callConnectionStatus.callMode,
              "callState": 1,
              "callTime": callLogs.initTime(),
              "callType": callConnectionStatus.callType,
              "fromUser": callConnectionStatus.from,
              "roomId": roomId,
              "userList": callConnectionStatus.userList,
              "groupId": callConnectionStatus.groupId
            });
            let callConnectionStatusNew = {
              ...callConnectionStatus,
              roomId: roomId
            }
            store.dispatch(addCallConnectionDate(callConnectionStatusNew));
            encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatusNew))
            startCallingTimer();
          }
        } catch (error) {
          if (error.message === premissionConst) {
            deleteAndDispatchAction();
          }
        }
    } else {
      toast.error(NO_INTERNET)
    }
  }



  const makeOne2OneCall = async (callType) => {
    if (isRoomExist() || preventMultipleClick) {
      return;
    }
    if (isAdminBlocked || isDeletedUser || isBlocked) return;
    if(blockOfflineMsgAction()) return
    preventMultipleClick = true;
    let connectionStatus = getFromLocalStorageAndDecrypt("connection_status")
    if (connectionStatus === CONNECTED) {
      let { userData:userDataLocal } = props
      let fromuser = props?.vCardData?.data?.fromUser;
      const rosterCallee = userDataLocal[0]?.roster
      let roomId = "";
      let activeChatIdLocal = formatUserIdToJid(activeChatId)
      let call = null;
      /**
      // resetPinAndLargeVideoUser();
      */
      let callMode = "onetoone";
      fromuser = formatUserIdToJid(fromuser);
      const { image , thumbImage } = rosterCallee
      let callConnectionStatus = {
        callMode: callMode,
        callStatus: "CALLING",
        callType: callType,
        to: activeChatIdLocal,
        from: fromuser,
        userList: activeChatIdLocal,
        userAvatar: thumbImage ? thumbImage : image
      }
      encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatus));
      encryptAndStoreInLocalStorage('callType', callType)
      encryptAndStoreInLocalStorage('callingComponent', true)
      encryptAndStoreInLocalStorage('callFrom', getFromLocalStorageAndDecrypt('loggedInUserJidWithResource'));
      store.dispatch(addCallConnectionDate(callConnectionStatus));
      const showConfrenceData = store.getState().showConfrenceData;
      const {
        data
      } = showConfrenceData;
      store.dispatch(addShowConfrenceData({
          localStream: data?.localStream,
          localVideoMuted: data?.localVideoMuted,
          localAudioMuted: data?.localAudioMuted,
          showComponent: true,
          callStatusText: 'Calling'
      }));
      preventMultipleClick = false;
      try {
        if (callType === "audio") {
          muteLocalVideo(true);
          call = await SDK.makeVoiceCall([activeChatIdLocal], null);
        } else if (callType === "video") {
          muteLocalVideo(false);
          call = await SDK.makeVideoCall([activeChatIdLocal], null);
        }
        if (call.statusCode !== 200 && call.message === premissionConst) {
          deleteAndDispatchAction();
        } else {
          roomId = call.roomId;
          encryptAndStoreInLocalStorage('roomName', roomId)
          callLogs.insert({
            "callMode": callConnectionStatus.callMode,
            "callState": 1,
            "callTime": callLogs.initTime(),
            "callType": callConnectionStatus.callType,
            "fromUser": callConnectionStatus.from,
            "roomId": roomId,
            "userList": callConnectionStatus.userList
          });
          let callConnectionStatusNew = { ...callConnectionStatus, roomId: roomId };
          encryptAndStoreInLocalStorage('call_connection_status', JSON.stringify(callConnectionStatusNew));
          store.dispatch(addCallConnectionDate(callConnectionStatusNew));
        }
      } catch (error) {
        console.log("Error in making call", error);
        if (error.message !== premissionConst) {
          deleteAndDispatchAction();
        }
      }
    } else {
      toast.error(NO_INTERNET)
      preventMultipleClick = false;
    }
  }

  const avatarIcon = chatType === 'chat' ? sampleChatProfile : SampleGroupProfile;
  // const imageToken = chatType !== "groupchat" ? roster?.image : roster?.groupImage
  // // const { thumbImage } = localRoster
  let isBlockedAdmins = getDataFromRoster(activeChatId) || {};
  let getBlockedAdmin = isBlockedAdmins.isAdminBlocked

  let blockedContactArr = blockedContact.data;
  const isBlocked = blockedContactArr.indexOf(chatJid) > -1;

  return (
    <React.Fragment>
      <div className="conversation-header">
        <div className="user-profile-name">
        {!conversationValue && <i className="arrow-icon" onClick={backToRecentChat}>
            <ArrowBackHoc />
          </i>}
          <div className="user-profile-name" onClick={handlePopUp}>
            <ProfileImage 
              chatType={chatType}
              userId={chatId}
              temporary={false}
              imageToken={getBlockedAdmin ? "" : getImage}
              emailId={roster?.emailId}
              name={getName || nickName}            
            />
            <div className="profile-name">
              <h4>{getName || nickName || chatId}</h4>
              {!getBlockedAdmin &&
                <TypingStatus
                  fromUserId={chatId}
                  jid={chatJid}
                  contactNames={displayNames}
                  chatType={chatType}
                  isBlock={!getBlockedAdmin}
                />
              }
            </div>
          </div>
        </div>
        <div className="profile-options">
          {canSendMessage() && ((isOneToOneCallEnabled && chatType === "chat") || (isGroupCallEnabled && chatType === 'groupchat')) && isCallEnabled &&
            <>
              <i title={showonGoingcallDuration ? 'You are already in call' : "Audio call"}
                  onClick={(chatType === "chat") ? () => makeOne2OneCall('audio') : () => showCallParticipants('audio')}
                  className={`audioCall ${(showonGoingcallDuration || isAdminBlocked || isDeletedUser || isBlocked) ? 'calldisabled' : ''}`}>
                  <span className="toggleAnimation"></span>
                  <AudioCallHoc viewBox="0 0 24 24"/>
                  
              </i>
              <i title={showonGoingcallDuration ? 'You are already in call' : "Video call"}
                  onClick={(chatType === "chat") ? () => makeOne2OneCall('video') : () => showCallParticipants('video')}
                  className={`videoCall ${(showonGoingcallDuration || isAdminBlocked || isDeletedUser || isBlocked) ? 'calldisabled' : ''}`}>
                  <span className="toggleAnimation"></span>
                  <VideoCallHoc viewBox="0 0 24 24"/>
              </i>
            </>
          }
        </div>
      </div>
      {conversationInfo.viewContactStatus &&
        <WebChatContactInfo
          rosterName={displayName}
          rosterImage={getImage}
          rosterGroupImage={getGroupImage}
          activeChatId={chatId}
          activeChatDatas={userData[0]}
          chatType={chatType}
          userstatus={userstatus}
          onInfoClose={handlePopUp}
          avatarIcon={avatarIcon}
          participants={groupMemberDetails}
          // handlePopUpClassActive={this.props.handlePopUpClassActive}
          mobileNumber={mobileNumber}
          roster={localRoster}
          getName={getName}
          isAdminBlocked={getBlockedAdmin}
        />
      }
    </React.Fragment>
  );
};

export default ConversationHeader;
